import { createApp } from 'vue'
import App from './App.vue'
import { useRouter } from './router'
import '@/assets/scss/global.scss'
import { vMaska } from 'maska/vue'
import { createPinia } from 'pinia'
import { useText } from './store/text.store'
import { useVehicle } from './store/vehicle.store'
import { useSettings } from './store/settings.store'

// @ts-ignore
import userMonitoring from './mixins/userMonitoring'
import { useConfigCat } from './store/config-cat.store'
import { initServiceWorker } from './mixins/registerServiceWorker'

// if (process.env.NODE_ENV === 'localse') {
//   makeServer()
// }

const initApp = async () => {
  const app = createApp(App)
  app.directive('maska', vMaska)
  const router = useRouter()
  app.use(router)
  app.use(createPinia())
  /*   app.use(Bricks) */

  useConfigCat().init()
  userMonitoring().init()

  initServiceWorker()

  // application
  const settingsStore = useSettings()

  // global text
  const textStore = useText()

  textStore.fetchAllTexts()

  textStore.fetchUsp()

  //settings
  settingsStore.fetchSettings()

  // makes
  const vehicleStore = useVehicle()
  vehicleStore.getCarMakeNames()
  app.mount('#app')
}

initApp()
